const FEATURES = {
  BASIC_ACCESS: "basic_access",
  COMMERCIAL_OFFER_EXPORT: "commercial_offer_export",
  TEMPLATE_ACCESS: "template_access",
  ADDITIONAL_EMPLOYEES: "additional_employees",
  ADDITIONAL_STORAGE: "additional_storage",
};

export default FEATURES;
